module.exports = __webpack_public_path__ + "media/images/courseware_sakai_courses_icon-72a25a9e29c57f2414e66a3a97b88a49.png";